// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingSpinner_spinner__igArT spinner-border","small":"LoadingSpinner_small__1vzXj spinner-border-sm"};